module.exports = __webpack_public_path__ + "static/media/video.20b71e3e.webm";